export default function flowIdManagment() {
    function _createSessionData(flowId) {
      return { id: flowId, date_time: new Date() };
    }
  
    function addToSessionStorage(flowId) {
      const data = _createSessionData(flowId);
      if (typeof data === "object" && data?.id && data?.date_time) {
        const jsonString = JSON.stringify(data);
        sessionStorage.setItem("flowData", jsonString);
      } else {
        console.error("Dados inválidos fornecidos para flowdata");
      }
    }
  
    function _getFlowDataFromSessionStorage() {
      const data = sessionStorage?.getItem("flowData");
      if (data) {
        return JSON.parse(data);
      } else {
        return null;
      }
    }
  
    function getFlowId() {
      const data = _getFlowDataFromSessionStorage();
      return data?.id;
    }
  
    function removeFlowDataFromSessionStorage() {
      sessionStorage.removeItem("flowData");
    }
  
    function manageFlowIdLifeSpan() {
      try {
        const flowData = _getFlowDataFromSessionStorage();
        if (flowData && flowData?.id && flowData?.date_time) {
          const createDate = new Date(flowData?.date_time);
          const dateNow = new Date();
          const timeDifference = dateNow?.getTime() - createDate?.getTime();
          const dataLifeSpan = timeDifference / (1000 * 60 * 60);
          if (dataLifeSpan >= process.env.REACT_APP_FLOW_ID_LIFE_SPAN) {
            removeFlowDataFromSessionStorage();
          }
        }
      } catch (error) {}
    }
  
    return {
      addToSessionStorage,
      removeFlowDataFromSessionStorage,
      manageFlowIdLifeSpan,
      getFlowId,
    };
  }
  